import React from 'react';
import { ACCENT_HEX, type JuniorAccent } from '../../lib/juniorTheme';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';

interface JuniorAliveZoneProps {
  children: React.ReactNode;
  className?: string;
  accent?: JuniorAccent;
  showOrbs?: boolean;
}

export const JuniorAliveOrbs: React.FC<{ accent?: JuniorAccent }> = ({ accent = 'coral' }) => {
  const hex = ACCENT_HEX[accent];
  return (
    <div
      className="junior-alive-orb pointer-events-none absolute -top-16 right-[-4rem] h-56 w-56 rounded-full blur-2xl"
      style={{ background: `radial-gradient(circle, ${hex}45 0%, transparent 70%)` }}
      aria-hidden
    />
  );
};

interface JuniorAliveBackButtonProps {
  to: string;
  label: string;
  className?: string;
  onNavigate?: (to: string) => void;
}

export const JuniorAliveBackButton: React.FC<JuniorAliveBackButtonProps> = ({
  to,
  label,
  className = '',
  onNavigate,
}) => {
  const { navigateAlive } = useJuniorAliveNav();
  return (
    <button
      type="button"
      onClick={() => (onNavigate ? onNavigate(to) : navigateAlive(to))}
      className={`inline-flex items-center gap-2 text-sm font-bold mb-8 transition-colors hover:opacity-70 ${className}`}
      style={{ color: '#6B6385' }}
    >
      ← {label}
    </button>
  );
};

export const JuniorAliveZone: React.FC<JuniorAliveZoneProps> = ({
  children,
  className = '',
  accent = 'coral',
  showOrbs = true,
}) => {
  const { animateEntry, containerRef } = useJuniorAliveNav();
  return (
    <div ref={containerRef} className={`junior-alive-page relative overflow-hidden ${className}`}>
      {animateEntry && showOrbs && <JuniorAliveOrbs accent={accent} />}
      {children}
    </div>
  );
};

export default JuniorAliveZone;
